/**
 * @ngdoc service
 * @name farmnet.base.tracking.piwik
 * @description
 * Wrapper around the global piwik object.
 * See http://developer.piwik.org/api-reference/tracking-javascript
 * for all supported methods.
 *
 * CFNPOC-7585 - The file must not be "Piwik.js" since it will be blocked
 * by some ad-blockers (Ghostery and µ)
 */
Piwik.$inject = ['$window'];
function Piwik($window) {
  /**
   * Specify the Piwik server URL.
   * @param {string} trackerUrl
   */
  this.setTrackerUrl = function(trackerUrl) {
  };

  /**
   * Specify the website ID.
   * @param {integer} siteId
   */
  this.setSiteId = function(siteId) {
  };

  /**
   * Install link tracking on all applicable link elements. Set the enable parameter
   * to true to use a pseudo-click handler to track browsers (such as Firefox) which
   * don't generate click events for the middle mouse button. By default only "true"
   * mouse click events are handled.
   * @param {boolean} [enable]
   * Default value is true.
   */
  this.enableLinkTracking = function(enable) {
  };

  /**
   * Sets a User ID to this user (such as an email address or a username).
   * @param {string} userId
   */
  this.setUserId = function(userId) {
  };

  /**
   * The visit scope for a custom variable. It will be saved as a
   * variable for the visitor in his current visit.
   * @type {string}
   */
  this.SCOPE_VISIT = 'visit';

  /**
   * The page scope for a custom variable. It will be saved for the
   * current page view (i.e. route view in AngularJS).
   * @type {string}
   */
  this.SCOPE_PAGE = 'page';

  /**
   * Set a custom variable.
   * @param {integer} index
   * The unique index in piwik. Piwik supports up to five custom variables
   * as default.
   * (More can be configured.)
   * @param {string} name
   * The unique name of a custom variable.
   * @param {string|integer} value
   * The value for the variable.
   * @param {SCOPE_VISIT|SCOPE_PAGE} scope
   * If the custom variable should be tracked for the visitor or
   * for the page.
   */
  this.setCustomVariable = function(index, name, value, scope) {
  };

  /**
   * Set a custom variable for with visit scope.
   * @param {integer} index
   * The unique index in piwik. Piwik supports up to five custom variables
   * as default.
   * (More can be configured.)
   * @param {string} name
   * The unique name of a custom variable.
   * @param {string|integer} value
   * The value for the variable.
   */
  this.setCustomVariableForVisit = function(index, name, value) {
  };

  /**
   * Set a custom variable for page scope.
   * @param {integer} index
   * The unique index in piwik. Piwik supports up to five custom variables
   * as default.
   * (More can be configured.)
   * @param {string} name
   * The unique name of a custom variable.
   * @param {string|integer} value
   * The value for the variable.
   */
  this.setCustomVariableForPage = function(index, name, value) {
  };

  /**
   * Override the page's reported URL.
   * @param {string} url
   */
  this.setCustomUrl = function(url) {
  };

  /**
   * Override document.title reported to Piwik.
   * @param {string} title
   */
  this.setDocumentTitle = function(title) {
  };

  /**
   * Logs a visit to this page
   * @param {string} [title]
   * The document title reported to Piwik.
   * @param {string} [url]
   * The page's (route's) url reported to Piwik.
   */
  this.trackPageView = function(title, url) {
  };

  /**
   * Logs an event with an event category (Videos, Music, Games...), an event action
   * (Play, Pause, Duration, Add Playlist, Downloaded, Clicked...), and an optional
   * event name and optional numeric value.
   * @param {string} category
   * @param {string} action
   * @param {string} [name]
   * @param {number} [value]
   */
  this.trackEvent = function(category, action, name, value) {
  };

  /**
   * Manually log a conversion for the goal with id goalId, passing in the custom
   * revenue customRevenue if specified.
   * @param {integer} goalId
   * @param {number} [customRevenue]
   */
  this.trackGoal = function(goalId, customRevenue) {
  };
}

export default Piwik;
